import React from 'react';
import styled from 'styled-components';

export const StyledImage = styled.img`
  max-width: 50%;
  height: auto;
`;

export const Image = ({ ...rest }) => <StyledImage {...rest} />;
